import { React, useCallback, useState, useEffect, useRef, useSyncExternalStore } from 'react'
import { NavLink, useNavigate } from 'react-router-dom'

import { AiOutlineArrowLeft } from 'react-icons/ai'
import { RiWechatLine, RiSettings4Line } from 'react-icons/ri'
import { MdOutlineGroups, MdOutlineMyLocation } from 'react-icons/md'
import { ReactComponent as BrowseActivityIcon } from '../assets/browse_activity.svg'
import newlogo from '../assets/metrinome-logo-new.png'
import '../layouts/stylesheets/tooltip.css'
import { clearAuthStorage, hasAuthToken, subscribeToAuthChanges } from '../services/auth'

var setInitials = undefined
const SideMenu = (props) => {
  const [showMenuState, setShowMenuState] = useState(false)
  const isSignedIn = useSyncExternalStore(
    subscribeToAuthChanges,
    hasAuthToken,
    hasAuthToken
  )
  const isAuthorized = props.isAuthorized ?? isSignedIn
  const hideBackArrow = props.hideBackArrow ?? false
  const [initials, newSetInitials] = useState(
    localStorage.getItem('ontrack-name-initials')
  )
  setInitials = newSetInitials

  const navigate = useNavigate()
  const dropdownMenu = useRef()
  const showMenu = (event) => {
    event.stopPropagation()
    setShowMenuState(true)
  }
  const closeMenu = useCallback((event) => {
    if (dropdownMenu.current || !dropdownMenu.current?.contains(event.target)) {
      setShowMenuState(false)
    }
  }, [])
  useEffect(() => {
    if (showMenuState) {
      document.addEventListener('click', closeMenu)
    } else {
      document.removeEventListener('click', closeMenu)
    }
  }, [closeMenu, showMenuState])

  const signOut = () => {
    clearAuthStorage()
    navigate('/signin', { replace: true })
  }

  return (
    <div className={`w-24 min-w-24 shrink-0 self-stretch min-h-screen p-2 sticky top-0 bg-[#E8EEE7] border-r border-[#D1DDD2] ${props.className}`}>
      <div
        className="pt-8 text-2xl flex flex-col min-h-screen rounded-t rounded-b"
        style={{ backgroundColor: '#E8EEE7' }}
      >
        <div className="flex items-center justify-center mb-16">
          {isAuthorized && (
            <NavLink className="font-semibold" to="/trackers" aria-label="Trackers">
              <img
                className="w-[46px] h-[46px] cursor-pointer"
                src={newlogo}
                alt="Logo"
              />
            </NavLink>
          )}
          {!isAuthorized && (
            <NavLink className=" font-semibold " to="/">
              <img
                className="w-[46px] h-[46px] cursor-pointer"
                src={newlogo}
                alt="Logo"
              />
            </NavLink>
          )}
        </div>
        {!isAuthorized && !hideBackArrow && (
          <div className="h-10 hover:bg-slate-300 rounded-md mb-2 relative">
            <NavLink
              className="tooltip relative flex items-center justify-center w-full h-full"
              to="/"
              aria-label="Return to Main Menu"
            >
              <AiOutlineArrowLeft />
            </NavLink>
            <span className="tooltiptext bottom-[0.425rem] left-[100%] text-sm w-[170px]">
              Return to Main Menu
            </span>
          </div>
        )}
        {isAuthorized && (
          <>
            <div className="h-10 hover:bg-slate-300 rounded-md mb-2 relative">
              <NavLink
                className="tooltip relative flex items-center justify-center w-full h-full"
                to="/trackers"
                aria-label="Trackers"
              >
                <MdOutlineMyLocation />
              </NavLink>
              <span className="tooltiptext bottom-[0.425rem] left-[100%] text-sm w-[170px]">
                Trackers
              </span>
            </div>
            <div className="h-10 hover:bg-slate-300 rounded-md mb-2 relative">
              <NavLink
                className="tooltip relative flex items-center justify-center w-full h-full"
                to="/account-summary"
              >
                <MdOutlineGroups />
              </NavLink>
              <span className="tooltiptext bottom-[0.425rem] left-[100%] text-sm w-[130px]">
                Account Summary
              </span>
            </div>
            <div className="mt-auto">
              {/*<div className="h-10 hover:bg-slate-300 rounded-md mb-2 relative">
                <NavLink
                  className="tooltip relative flex items-center justify-center w-full h-full"
                  to="/invite-user"
                >
                  <MdOutlineGroupAdd />
                </NavLink>
                <span className="tooltiptext bottom-[0.425rem] left-[100%] text-sm w-[90px]">
                  Invite User
                </span>
              </div>*/}
              <div className="h-10 hover:bg-slate-300 rounded-md mb-2 relative">
                <NavLink
                className="tooltip relative flex items-center justify-center w-full h-full"
                  to="/admin-cves"
                >
                  <BrowseActivityIcon className="h-6 w-6" />
                </NavLink>
                <span className="tooltiptext bottom-[0.425rem] left-[100%] text-sm w-[70px]">
                  CVEs
                </span>
              </div>
              <div className="h-10 hover:bg-slate-300 rounded-md mb-2 relative">
                <NavLink
                  className="tooltip relative flex items-center justify-center w-full h-full"
                  to="/support"
                >
                  <RiWechatLine />
                </NavLink>
                <span className="tooltiptext bottom-[0.425rem] left-[100%] text-sm w-[70px]">
                  Support
                </span>
              </div>
              <div className="h-10 hover:bg-slate-300 rounded-md mb-2 relative">
                <NavLink
                  className="tooltip relative flex items-center justify-center w-full h-full"
                  to="/settings"
                >
                  <RiSettings4Line />
                </NavLink>
                <span className="tooltiptext bottom-[0.425rem] left-[100%] text-sm w-[70px]">
                  Settings
                </span>
              </div>
              <div className="flex justify-center items-center mb-4 relative">
                <div
                  className="flex justify-center items-center w-14 h-14 rounded-full cursor-pointer"
                  style={{ backgroundColor: '#FFFFFF', border: '1px solid #E4E4E7' }}
                  onClick={showMenu}
                >
                  <div
                    className="dropdown inline-block relative font-unbounded"
                    ref={dropdownMenu}
                  >
                    {initials}
                  </div>
                </div>
                {showMenuState && (
                  <ul className="dropdown-menu absolute left-[100%] text-gray-700 pt-2 w-24 text-center text-lg">
                    <li className="">
                      <div
                        className="rounded-t bg-white hover:bg-gray-200 py-4 px-4 block whitespace-nowrap"
                        onClick={signOut}
                      >
                        Sign Out
                      </div>
                    </li>
                  </ul>
                )}
              </div>
            </div>
          </>
        )}
      </div>
    </div>
  )
}
SideMenu.doSetInitials = (v) => {
  if (setInitials) setInitials(v)
}

export default SideMenu
